import styled from "@emotion/styled"
import { NewText } from "ui"

type Props = {
  title: string
  subtitle: string
}

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
  text-align: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
`
const SectionTitles = ({ title, subtitle }: Props) => {
  return (
    <StyledDiv>
      <NewText
        component={"h2"}
        desktopFontSize={48}
        desktopFontWeight={600}
        mobileFontSize={40}
        desktopLineHeight={"100%"}
        mobileLineHeight={"46px"}
        color="#2768A3"
      >
        {title}
      </NewText>
      <NewText
        component={"p"}
        desktopFontSize={18}
        desktopFontWeight={400}
        mobileFontSize={16}
        desktopLineHeight={"100%"}
        style={{ paddingTop: "8px", color: "#000000" }}
      >
        {subtitle}
      </NewText>
    </StyledDiv>
  )
}

export default SectionTitles
